import { Model } from 'pinia-orm';
import ShareJobCard from './ShareJobCard';
import ShareJobSectionShareJobCard from './ShareJobSectionShareJobCard';

export default class ShareJobSection extends Model {

    static get entity () {
        return 'share_job_sections';
    }

    static fields () {
        return {
            id: this.uid(),
            icon: this.attr(null),
            enable_locales: this.boolean(false),
            active: this.boolean(false),
            description: this.attr({}),
            title: this.attr({}),
            order: this.number(0),

            cards: this.belongsToMany(ShareJobCard, ShareJobSectionShareJobCard, 'share_job_section_id', 'share_job_card_id'),
        }
    }
}